module.exports = __webpack_public_path__ + "img/dashboards.5899e924.png";